// Préférences client persistées (localStorage). Même robustesse que audio.ts : localStorage peut
// lever (profils « bloquer tous les cookies ») -> try/catch, on retombe sur le défaut.
import { AVATAR_HUES as SHARED_HUES, SKIN_IDS } from '../shared/skins'

function ls(k: string): string | null { try { return localStorage.getItem(k) } catch { return null } }
function lss(k: string, v: string): void { try { localStorage.setItem(k, v) } catch { /* profil sans stockage */ } }

// Dash (Lot D) : capacité activable par un interrupteur avant la partie. Défaut ON (fonction native) ;
// stockée '0'/'1'. Solo la lit à la création de partie ; l'écran « Jouer en ligne » l'utilise comme
// valeur par défaut de la case du salon.
const DASH_KEY = 'mad.dash'
export function dashPref(): boolean { return ls(DASH_KEY) !== '0' }
export function setDashPref(on: boolean): void { lss(DASH_KEY, on ? '1' : '0') }

// Torche (option graphique) : pénombre + halo autour du coureur suivi. Défaut OFF (assombrit
// l'aire de jeu -> opt-in) ; stockée '0'/'1'. Lue par render() à chaque frame.
const TORCH_KEY = 'mad.torch'
export function torchPref(): boolean { return ls(TORCH_KEY) === '1' }
export function setTorchPref(on: boolean): void { lss(TORCH_KEY, on ? '1' : '0') }

// FANTÔME DU RECORDMAN (25/07) : le coureur translucide du détenteur du record court à côté de toi.
// Défaut ON — c'est la raison d'être de la feature, et il disparaît de lui-même sur une carte que
// personne n'a encore finie. Stocké '0'/'1' ; l'absence de valeur vaut ON.
const GHOST_KEY = 'mad.ghost'
export function ghostPref(): boolean { return ls(GHOST_KEY) !== '0' }
export function setGhostPref(on: boolean): void { lss(GHOST_KEY, on ? '1' : '0') }

// ADVERSAIRE (26/07) : contre QUI on court. '' = automatique, le serveur envoie le plus rapide des
// autres joueurs. Un pseudo = ce joueur-là, chaque fois qu'il a couru la carte (et se désigner
// soi-même, c'est la chasse au record perso). Le serveur retombe seul sur l'automatique quand le
// joueur choisi n'a pas fini la carte : une valeur périmée ici ne prive donc jamais de fantôme.
const GHOST_RIVAL_KEY = 'mad.ghost.rival'
export function ghostRival(): string { return ls(GHOST_RIVAL_KEY) ?? '' }
export function setGhostRival(pseudo: string): void { lss(GHOST_RIVAL_KEY, pseudo) }

// Filtre arcade CRT (option graphique) : scanlines + vignette sur l'aire de jeu. Défaut OFF.
const CRT_KEY = 'mad.crt'
export function crtPref(): boolean { return ls(CRT_KEY) === '1' }
export function setCrtPref(on: boolean): void { lss(CRT_KEY, on ? '1' : '0') }

// Zoom caméra EN JEU (option, 21/07) : agrandit la couche monde et fait suivre le coureur par la
// caméra. Jauge dans les Réglages, de CAM_ZOOM_MIN (recul max = carte entière, comme avant) à
// CAM_ZOOM_MAX (zoom max, +50 %). Défaut CAM_ZOOM_DEF (+30 %). 100 % rendu : aucun impact
// simulation. Lue par render() à chaque frame (borne toujours dans [MIN, MAX]).
export const CAM_ZOOM_MIN = 1.0
export const CAM_ZOOM_MAX = 1.5
export const CAM_ZOOM_DEF = 1.3
export const CAM_ZOOM_STEP = 0.05
const CAMZOOM_KEY = 'mad.camzoom'
export function cameraZoom(): number {
  const raw = ls(CAMZOOM_KEY)
  if (raw === null) return CAM_ZOOM_DEF
  const v = Number(raw)
  if (!Number.isFinite(v)) return CAM_ZOOM_DEF
  return Math.min(CAM_ZOOM_MAX, Math.max(CAM_ZOOM_MIN, v))
}
export function setCameraZoom(z: number): void {
  lss(CAMZOOM_KEY, String(Math.min(CAM_ZOOM_MAX, Math.max(CAM_ZOOM_MIN, z))))
}

// Avatar : teinte (hue-rotate, degrés) de la TENUE du coureur LOCAL. -1 = couleur d'origine.
// Palette partagée (shared/skins.ts) depuis le chantier cartoon 19/07 : le générateur pré-cuit
// les 7 variantes par skin, le serveur valide les mêmes valeurs. Ré-export pour les écrans.
const AVATAR_KEY = 'mad.avatar'
export const AVATAR_HUES: readonly number[] = SHARED_HUES
export function avatarHue(): number { const v = ls(AVATAR_KEY); return v === null ? -1 : Number(v) }
export function avatarIndex(): number { const i = AVATAR_HUES.indexOf(avatarHue()); return i < 0 ? 0 : i }
/** Pose la teinte directement (sélecteur de personnage / alignement compte serveur). */
export function setAvatarHue(hue: number): void {
  lss(AVATAR_KEY, String((AVATAR_HUES as readonly number[]).includes(hue) ? hue : -1))
}
/** Passe à la teinte suivante de la palette (menu Réglages) et renvoie le NOUVEL index (pour le libellé). */
export function cycleAvatar(): number {
  const next = (avatarIndex() + 1) % AVATAR_HUES.length
  lss(AVATAR_KEY, String(AVATAR_HUES[next]))
  return next
}

// Skin (chantier cartoon 19/07) : personnage du joueur LOCAL, un des SKIN_IDS. Défaut 'standard'.
// Le compte serveur fera foi à la connexion (Lot 2) ; ici la préférence locale/hors-ligne.
const SKIN_KEY = 'mad.skin'
export function skinId(): string {
  const v = ls(SKIN_KEY)
  return v !== null && (SKIN_IDS as readonly string[]).includes(v) ? v : 'standard'
}
export function setSkinId(id: string): void { lss(SKIN_KEY, id) }
